(function () {
    'use strict';

    angular.module('nfseApp').controller('IntegracaoNotaNacionalController',
        function ($scope, NotaNacional, ParseLinks, localStorageService, Notificacao, Util, EnumCacheService) {
            $scope.lista = [];
            $scope.page = 1;
            $scope.per_page = 10;
            $scope.campos = [];
            $scope.links;
            $scope.listaReintegracao = [];
            $scope.resumoIntegracao = null;
            $scope.itensNaoEnfileirados = [];
            $scope.filtro = {};
            $scope.activeTab = 0;
            $scope.quantidadePorErro = [];
            $scope.graficoQuantidadePorErro = {};
            $scope.quantidadePorStatus = [];
            $scope.graficoQuantidadePorStatus = {};
            $scope.codigoErro = '';
            $scope.statusProcessamento = EnumCacheService.carregarValuesEnum("br.com.webpublico.domain.dto.enums.StatusProcessamentoDfeAdnDTO");
            console.log($scope.statusProcessamento);

            $scope.montarCampos = function () {
                $scope.campos = [];
                if ($scope.filtro.inscricaoCadastral) {
                    $scope.campos.push({
                        campo: 'dados.inscricao_cadastral',
                        operador: 'IGUAL',
                        valorString: $scope.filtro.inscricaoCadastral
                    });
                }
                if ($scope.filtro.numeroNotaFiscal) {
                    $scope.campos.push({
                        campo: 'dados.numero_nota_fiscal',
                        operador: 'IGUAL',
                        valorLong: $scope.filtro.numeroNotaFiscal
                    });
                }
                console.log($scope.filtro.status);
                if ($scope.filtro.status) {
                    $scope.campos.push({
                        campo: 'dados.status',
                        operador: 'IGUAL',
                        valorString: $scope.filtro.status.name
                    });
                }
                if ($scope.filtro.mensagem) {
                    $scope.campos.push({
                        campo: 'dados.mensagem',
                        operador: 'LIKE',
                        valorString: '%' + $scope.filtro.mensagem + '%'
                    });
                }
                localStorageService.set('filtroIntegracaoNotaNacional', $scope.filtro);
            };

            $scope.loadAll = function () {
                var parametrosQuery = [];
                if ($scope.campos.length > 0) {
                    parametrosQuery.push({
                        juncao: ' and ',
                        parametroQueryCampos: $scope.campos
                    });
                }
                NotaNacional.buscarIntegracoes({
                        offset: $scope.page,
                        limit: $scope.per_page,
                        parametrosQuery: parametrosQuery
                    },
                    function (result, headers) {
                        if (headers)
                            $scope.links = ParseLinks.parse(headers('link'));
                        $scope.lista = result;
                    });
            };

            $scope.loadPage = function (page) {
                $scope.page = page;
                $scope.loadAll();
            };

            $scope.buscarIntegracoes = function () {
                $scope.page = 1;
                $scope.montarCampos();
                $scope.loadAll();
            }

            $scope.limparFiltros = function () {
                $scope.page = 1;
                $scope.filtro = {};
                $scope.campos = [];
                $scope.loadAll();
            }

            // Documentos que ainda têm o que comunicar ao nacional. NFS-e já integrada e evento já
            // processado não são reenviáveis — marcá-los só produzia rejeição repetida.
            // NFSE_JA_EXISTENTE_ADN continua marcável de propósito: a DPS não é reenviada, mas é
            // marcando a linha que o operador obtém o motivo (documento no nacional sem a chave de
            // acesso registrada, ou o que falta para o evento de cancelamento dessa nota).
            $scope.podeReprocessar = function (item) {
                return item && (item.situacaoIntegracao === 'DPS_PENDENTE' ||
                    item.situacaoIntegracao === 'EVENTO_CANCELAMENTO_PENDENTE' ||
                    item.situacaoIntegracao === 'NFSE_JA_EXISTENTE_ADN' ||
                    item.situacaoIntegracao === 'ERRO_PROCESSAMENTO');
            }

            // A lista traz uma linha por nota e tipo de documento (NFS-e e eventos de cancelamento),
            // então a seleção precisa identificar os dois — e o servidor decide a operação de cada um.
            $scope.indiceReintegracao = function (item) {
                for (var i = 0; i < $scope.listaReintegracao.length; i++) {
                    var selecionado = $scope.listaReintegracao[i];
                    if (selecionado.idNotaFiscal === item.idNotaFiscal && selecionado.tipo === item.tipo) {
                        return i;
                    }
                }
                return -1;
            }

            $scope.adicionarTodasParaReintegracao = function () {
                for (var i = 0; i < $scope.lista.length; i++) {
                    if ($scope.podeReprocessar($scope.lista[i]) && !$scope.paraReintegrar($scope.lista[i])) {
                        $scope.listaReintegracao.push($scope.lista[i]);
                    }
                }
            }

            $scope.removerTodasParaReintegracao = function () {
                for (var i = 0; i < $scope.lista.length; i++) {
                    if ($scope.podeReprocessar($scope.lista[i]) && $scope.paraReintegrar($scope.lista[i])) {
                        $scope.listaReintegracao.splice($scope.indiceReintegracao($scope.lista[i]), 1);
                    }
                }
            }

            $scope.adicionarOuRemoverReintegracao = function (item) {
                var indice = $scope.indiceReintegracao(item);
                if (indice != -1) {
                    $scope.listaReintegracao.splice(indice, 1);
                } else {
                    $scope.listaReintegracao.push(item);
                }
            }

            $scope.paraReintegrar = function (item) {
                return $scope.indiceReintegracao(item) != -1;
            }

            // Só os itens que não foram enfileirados ficam na tela: o operador precisa do motivo para
            // saber se falta providência (deferir o cancelamento, aguardar a substituta) ou se não há
            // mais nada a comunicar daquele documento.
            $scope.tratarResumoIntegracao = function (resumo) {
                $scope.resumoIntegracao = resumo;
                $scope.itensNaoEnfileirados = [];
                var itens = resumo && resumo.itens ? resumo.itens : [];
                for (var i = 0; i < itens.length; i++) {
                    if (!itens[i].enfileirado) {
                        $scope.itensNaoEnfileirados.push(itens[i]);
                    }
                }
                var enfileirados = resumo ? resumo.quantidadeEnfileirada : 0;
                if (enfileirados > 0) {
                    Notificacao.info('Informação!', enfileirados +
                        ' documento(s) enviado(s) para a Nfs-e Nacional.');
                }
                if ($scope.itensNaoEnfileirados.length > 0) {
                    Notificacao.warn('Atenção!', $scope.itensNaoEnfileirados.length +
                        ' documento(s) não foram enviados. Veja os motivos abaixo da listagem.');
                }
                if (enfileirados == 0 && $scope.itensNaoEnfileirados.length == 0) {
                    Notificacao.info('Informação!', 'Nenhum documento pendente de envio.');
                }
                if (resumo && resumo.limiteLoteAtingido) {
                    Notificacao.warn('Atenção!', 'O processamento parou no limite de documentos por ' +
                        'acionamento. Podem restar pendentes — acione novamente para continuar.');
                }
            }

            $scope.enviarReintegracao = function () {
                if ($scope.listaReintegracao.length == 0) {
                    Notificacao.warn('Atenção!', 'Nenhum documento foi marcado para reintegração.');
                    return;
                }
                var documentos = [];
                for (var i = 0; i < $scope.listaReintegracao.length; i++) {
                    var selecionado = $scope.listaReintegracao[i];
                    documentos.push({
                        idNotaFiscal: selecionado.idNotaFiscal,
                        numeroNotaFiscal: selecionado.numeroNotaFiscal,
                        tipoDfe: selecionado.tipo
                    });
                }
                $scope.reintegrando = true;
                NotaNacional.integrarDocumentos(documentos, function (resumo) {
                    $scope.reintegrando = false;
                    $scope.listaReintegracao = [];
                    $scope.tratarResumoIntegracao(resumo);
                    $scope.loadAll();
                }, function () {
                    $scope.reintegrando = false;
                });
            }

            $scope.reenviarEventosCancelamentoPendentes = function () {
                $scope.reenviandoPendentes = true;
                NotaNacional.integrarEventosCancelamentoPendentes({}, function (quantidade) {
                    $scope.reenviandoPendentes = false;
                    if (quantidade && quantidade.value > 0) {
                        Notificacao.info('Informação!', quantidade.value +
                            ' cancelamento(s) enviado(s) para a Nfs-e Nacional.');
                    } else {
                        Notificacao.info('Informação!', 'Nenhum cancelamento pendente de envio.');
                    }
                }, function () {
                    $scope.reenviandoPendentes = false;
                });
            }

            $scope.reintegrarNotasPorCodigoErro = function () {
                if (!$scope.codigoErro) {
                    Notificacao.warn('Atenção!', 'Informe o código do erro para reintegração.');
                    return;
                }
                $scope.reintegrandoPorCodigoErro = true;
                NotaNacional.reintegrarNotasPorCodigoErro({codigoErro: $scope.codigoErro},
                    function (resumo) {
                        $scope.reintegrandoPorCodigoErro = false;
                        $scope.codigoErro = '';
                        $scope.tratarResumoIntegracao(resumo);
                    }, function () {
                        $scope.reintegrandoPorCodigoErro = false;
                    });
            }

            $scope.montarGraficoQuantitativo = function (data) {
                var grafico = {
                    labels: [],
                    data: []
                };
                if (data) {
                    for (var i = 0; i < data.length; i++) {
                        grafico.labels.push(data[i].descricao.length > 60 ? data[i].descricao.substring(0, 60) : data[i].descricao);
                        grafico.data.push(data[i].quantidade);
                    }
                }
                return grafico;
            }

            $scope.buscarInformacoesGraficos = function () {
                NotaNacional.buscarQuantidadePorErro({}, function (data) {
                    $scope.quantidadePorErro = data;
                    $scope.graficoQuantidadePorErro = $scope.montarGraficoQuantitativo(data);
                });
                NotaNacional.buscarQuantidadePorStatus({}, function (data) {
                    $scope.quantidadePorStatus = data;
                    $scope.graficoQuantidadePorStatus = $scope.montarGraficoQuantitativo(data);
                });
            }

            $scope.verIntegracoes = function () {
                $scope.activeTab = 0;
            };

            $scope.verGraficos = function () {
                $scope.activeTab = 1;
                $scope.buscarInformacoesGraficos();
            }

            $scope.init = function () {
                $scope.verIntegracoes();
            }

            $scope.init();

        });
})
();
